import React from "react";
import { motion } from "framer-motion";
import {
  FaFlask,
  FaMicroscope,
  FaDesktop,
  FaLanguage,
  FaAtom,
} from "react-icons/fa";

import biologyImg from "../assets/lab23.jpeg";
import chemistryImg from "../assets/lab12.jpeg";
import ictImg from "../assets/it lab.jpeg";
import languageImg from "../assets/lab5.jpg";
import physicsImg from "../assets/lab34.jpeg";

const Labs = () => {
  return (

    <section className="bg-[#f8fbff] overflow-hidden">

      {/* ================= HERO ================= */}

      <section className="relative py-24 bg-gradient-to-br from-[#07294d] via-[#0b3d68] to-[#07294d] overflow-hidden">

        <div className="absolute top-0 left-0 w-full h-full opacity-10">

          <div className="absolute top-20 left-20 w-72 h-72 rounded-full bg-[#d4af37] blur-3xl"></div>

          <div className="absolute bottom-10 right-10 w-80 h-80 rounded-full bg-blue-300 blur-3xl"></div>

        </div>

        <div className="max-w-7xl mx-auto px-6 relative z-10">

          <motion.div
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: .7 }}
            viewport={{ once: true }}
            className="text-center"
          >

            <span className="inline-block px-6 py-2 rounded-full bg-white/20 text-white font-semibold tracking-[3px]">

              INFRASTRUCTURE

            </span>

            <h1 className="text-5xl md:text-7xl font-black text-white mt-8">

              Science &
              <span className="text-[#d4af37]">

                {" "}Computer Labs

              </span>

            </h1>

            <div className="w-32 h-1 bg-[#d4af37] mx-auto rounded-full mt-8 mb-8"></div>

            <p className="max-w-4xl mx-auto text-white/90 text-xl leading-10">

              Cambridge International School provides modern,
              well-equipped laboratories where students gain
              practical knowledge through observation,
              experimentation and interactive learning.

            </p>

          </motion.div>

        </div>

      </section>

      {/* ================= BIOLOGY LAB ================= */}

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">

        <div className="grid lg:grid-cols-2 gap-14 items-center">

          {/* LEFT CONTENT */}

          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: .7 }}
            viewport={{ once: true }}
          >

            <span className="inline-flex items-center gap-2 rounded-full bg-green-100 text-green-700 px-5 py-2 text-sm font-semibold">

              <FaMicroscope />

              BIOLOGY LAB

            </span>

            <h2 className="mt-6 text-4xl lg:text-5xl font-black text-[#07294d]">

              Biology Laboratory

            </h2>

            <div className="w-24 h-1 bg-green-500 rounded-full mt-6 mb-8"></div>
                        <p className="text-gray-600 text-lg leading-9 mb-6">

              There are numerous preserved biological specimens to
              observe and study, widening the exposure of students
              to the world of Biology. Biology activities and
              experiments are educational, exciting, and often
              times great fun.

            </p>

            <p className="text-gray-600 text-lg leading-9">

              In science, a model represents idea or process that
              is used to describe and explain phenomenon that
              cannot be experienced directly. Our budding
              scientists and engineers prepared model on Waste
              Water Treatment Plant and participated in Sahodaya
              Model Making Competition.

            </p>

          </motion.div>

          {/* RIGHT IMAGE */}

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: .7 }}
            viewport={{ once: true }}
          >

            <div className="overflow-hidden rounded-[35px] shadow-2xl">

              <img
                src={biologyImg}
                alt="Biology Lab"
                className="w-full h-[520px] object-cover hover:scale-105 transition duration-700"
              />

            </div>

          </motion.div>

        </div>

      </section>

      {/* ================= CHEMISTRY LAB ================= */}

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">

        <div className="grid lg:grid-cols-2 gap-14 items-center">

          {/* LEFT IMAGE */}

          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: .7 }}
            viewport={{ once: true }}
          >

            <div className="overflow-hidden rounded-[35px] shadow-2xl">

              <img
                src={chemistryImg}
                alt="Chemistry Lab"
                className="w-full h-[520px] object-cover hover:scale-105 transition duration-700"
              />

            </div>

          </motion.div>

          {/* RIGHT CONTENT */}

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: .7 }}
            viewport={{ once: true }}
          >

            <span className="inline-flex items-center gap-2 rounded-full bg-blue-100 text-blue-700 px-5 py-2 text-sm font-semibold">

              <FaFlask />

              CHEMISTRY LAB

            </span>

            <h2 className="mt-6 text-4xl lg:text-5xl font-black text-[#07294d]">

              Chemistry Laboratory

            </h2>

            <div className="w-24 h-1 bg-blue-500 rounded-full mt-6 mb-8"></div>

            <p className="text-gray-600 text-lg leading-9 mb-6">

              The facilities and wide range of chemicals and
              apparatus allow the students a hands-on experience
              in learning Chemistry.

            </p>

            <p className="text-gray-600 text-lg leading-9">

              It is really nice to get them in here with hands-on
              activities. They get really excited and want to be
              engaged.

            </p>

          </motion.div>

        </div>

      </section>
            {/* ================= ICT LAB ================= */}

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">

        <div className="grid lg:grid-cols-2 gap-14 items-center">

          {/* LEFT CONTENT */}

          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: .7 }}
            viewport={{ once: true }}
          >

            <span className="inline-flex items-center gap-2 rounded-full bg-cyan-100 text-cyan-700 px-5 py-2 text-sm font-semibold">

              <FaDesktop />

              ICT LAB

            </span>

            <h2 className="mt-6 text-4xl lg:text-5xl font-black text-[#07294d]">

              Information & Communication Technology Lab

            </h2>

            <div className="w-24 h-1 bg-cyan-500 rounded-full mt-6 mb-8"></div>

            <p className="text-gray-600 text-lg leading-9 mb-6">

              <strong>
                "Technology is a tool. It can give learner a voice that may not have had before."
              </strong>

            </p>

            <p className="text-gray-600 text-lg leading-9 mb-6">

              Computers have become an integral part of the life for our young
              ones. It's not just a part of technology but teaches us various
              means of modernization.

            </p>

            <p className="text-gray-600 text-lg leading-9 mb-6">

              The School has well-equipped computer labs to urge the students
              into the foray of advanced Computer skills. All the computers are
              equipped with updated software's and advanced technical aids to
              learn programming, web designing and app-development to have
              critical and analytical skills.

            </p>

            <p className="text-gray-600 text-lg leading-9 mb-6">

              The highly qualified teachers bring about new confidence in the
              students by making them aware of using technology. Computer
              teaching is used as an integral part of the teaching learning
              process.

            </p>

            <p className="text-gray-600 text-lg leading-9">

              The Computer Lab in our school is like a workshop which helps in
              developing our brain where all students learn by doing and not
              just by mere reading. It teaches the students not just Computer
              Science as a subject, but also the integration of computer skills
              for learning of other subjects in the curriculum.

            </p>

          </motion.div>

          {/* RIGHT IMAGE */}

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: .7 }}
            viewport={{ once: true }}
          >

            <div className="overflow-hidden rounded-[35px] shadow-2xl">

              <img
                src={ictImg}
                alt="ICT Lab"
                className="w-full h-[520px] object-cover hover:scale-105 transition duration-700"
              />

            </div>

          </motion.div>

        </div>

      </section>

      {/* ================= LANGUAGE LAB ================= */}

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">

        <div className="grid lg:grid-cols-2 gap-14 items-center">

          {/* LEFT IMAGE */}

          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: .7 }}
            viewport={{ once: true }}
          >

            <div className="overflow-hidden rounded-[35px] shadow-2xl">

              <img
                src={languageImg}
                alt="Language Lab"
                className="w-full h-[520px] object-cover hover:scale-105 transition duration-700"
              />

            </div>

          </motion.div>

          {/* RIGHT CONTENT */}

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: .7 }}
            viewport={{ once: true }}
          >

            <span className="inline-flex items-center gap-2 rounded-full bg-purple-100 text-purple-700 px-5 py-2 text-sm font-semibold">

              <FaLanguage />

              LANGUAGE LAB

            </span>

            <h2 className="mt-6 text-4xl lg:text-5xl font-black text-[#07294d]">

              Language Laboratory

            </h2>

            <div className="w-24 h-1 bg-purple-500 rounded-full mt-6 mb-8"></div>

            <p className="text-gray-600 text-lg leading-9 mb-6">

              Cambridge International School, Nakodar provides interactive
              learning sessions that are held in the Language Lab through
              audio visual aids.

            </p>

            <p className="text-gray-600 text-lg leading-9 mb-6">

              The school's Language Laboratory is a dedicated space for
              Foreign Language Learning where students access audio or
              audio-visual materials. It is a well furnished and well
              equipped room which helps the students to acquire the four
              main skills: Listening, Speaking, Reading and Writing in an
              entertaining and interactive way.

            </p>

            <p className="text-gray-600 text-lg leading-9">

              Our main objective is to equip our students with good
              communication skills, and to emphasize the need of English
              in the technical world.

            </p>

          </motion.div>

        </div>

      </section>
            {/* ================= PHYSICS LAB ================= */}

      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">

        <div className="grid lg:grid-cols-2 gap-14 items-center">

          {/* LEFT CONTENT */}

          <motion.div
            initial={{ opacity: 0, x: -40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: .7 }}
            viewport={{ once: true }}
          >

            <span className="inline-flex items-center gap-2 rounded-full bg-orange-100 text-orange-700 px-5 py-2 text-sm font-semibold">

              <FaAtom />

              PHYSICS LAB

            </span>

            <h2 className="mt-6 text-4xl lg:text-5xl font-black text-[#07294d]">

              Physics Laboratory

            </h2>

            <div className="w-24 h-1 bg-orange-500 rounded-full mt-6 mb-8"></div>

            <p className="text-gray-600 text-lg leading-9 mb-6">

              The equipment for Physics allows students to perform
              experiments and study various principles and laws.

            </p>

            <p className="text-gray-600 text-lg leading-9">

              The lab is very well furnished and is well equipped
              with all the apparatus that are necessary enough to
              impart practical knowledge to the students and help
              them understand the importance of Physics and its
              applications in day to day life.

            </p>

          </motion.div>

          {/* RIGHT IMAGE */}

          <motion.div
            initial={{ opacity: 0, x: 40 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: .7 }}
            viewport={{ once: true }}
          >

            <div className="overflow-hidden rounded-[35px] shadow-2xl">

              <img
                src={physicsImg}
                alt="Physics Lab"
                className="w-full h-[520px] object-cover hover:scale-105 transition duration-700"
              />

            </div>

          </motion.div>

        </div>

      </section>

    </section>

  );
};

export default Labs;